<template>
    <div>  
        <i-table :columns="columns" url="/haierEmpSettlementCompany/selectPage.json"  ref="table" v-if="companyUpdated">
            <template slot-scope="{ row, index }" slot="attachmentUrl">
                <div class="ellipsis">
                    <el-tooltip class="item" effect="dark" :content="row.companyName" placement="top-start">
                        <a @click="toDetail(row)" target="_blank">{{row.companyName}}</a> 
                    </el-tooltip> 
                </div>
            </template>
            <template slot-scope="{ row, index }" slot="companyAddressShow">
                <div class="ellipsis">
                    <el-tooltip class="item" effect="dark" :content="row.companyAddressShow" placement="top-start">
                        <span>{{row.companyAddressShow}}</span>
                    </el-tooltip> 
                </div>
            </template>
            <template slot-scope="{ row, index }" slot="companyType">
                <div class="ellipsis">
                    <el-tooltip class="item" effect="dark" :content="row.companyType" placement="top-start">
                        <span>{{row.companyType}}</span>
                    </el-tooltip> 
                </div>
            </template>
            <template slot-scope="{ row, index }" slot="industry">
                <div class="ellipsis">
                    <el-tooltip class="item" effect="dark" :content="row.industry" placement="top-start">
                        <span>{{row.industry}}</span>
                    </el-tooltip> 
                </div>
            </template>
            <template slot-scope="{ row, index }" slot="dataIntegrity">
                <span>{{row.dataIntegrity?'是':'否'}}</span>
            </template>
            <template slot-scope="{ row, index }" slot="action"> 
                <a @click="edit(row)">编辑</a>
            </template>
        </i-table>
       
        <!-- 详情 -->
        <Modal
            title="出账单位"
            v-model="detailVisible" 
            width="60%"
            :footer-hide="true">
            <div style="padding-left: 10px;">  
                <div class="plattit">单位信息</div>
                <el-row class="rowSty">
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="12" >
                                <span style="padding-right: 6px;">公司名称:</span>{{detail.companyName}}
                            </el-col> 
                        </el-row>
                    </el-col>
                </el-row>
                <el-row class="rowSty">
                    <el-col :span="12">
                        <span style="padding-right: 6px;">统一社会信用代码:</span>{{detail.organizationCode}}
                    </el-col>
                    <el-col :span="12">
                        <el-col :span="12"> <span style="padding-right: 6px;">企业类型:</span>{{detail.companyType}}</el-col> 
                    </el-col>
                </el-row>
                <el-row class="rowSty">
                    <el-col :span="12">
                        <span style="padding-right: 6px;">所属行业:</span>{{detail.industry}}
                    </el-col>
                    <el-col :span="12">
                        <span style="padding-right: 6px;">单位地址:</span>{{detail.companyAddressDesc}}{{detail.detailAddress}}
                    </el-col>
                </el-row> 
                <el-row class="rowSty"> 
                    <el-col :span="12">
                        <span style="padding-right: 6px;">邮政编码:</span>{{detail.postCode}} 
                    </el-col>
                    <el-col :span="12" class="oriang-box">
                        <span style="padding-right: 6px;">营业执照:</span>
                        <img v-if="detail.organizationUrl&&detail.organizationUrl.length>0" :src="detail.organizationUrl" alt=" " width="50px" height="50px"  @click="openOrganization">
                    </el-col>  
                </el-row>  
                <div class="plattit">联系人信息</div>
                <el-row class="rowSty">
                    <el-col :span="12">
                        <span style="padding-right: 6px;">姓名:</span>{{detail.name}}
                    </el-col>
                    <el-col :span="12">
                        <span style="padding-right: 6px;">电话:</span>{{detail.phone}} 
                    </el-col>
                </el-row>  
                <el-row  class="rowSty">
                    <el-col :span="12">
                        <span style="padding-right: 6px;">邮箱:</span>{{detail.email}}
                         
                    </el-col> 
                </el-row>   
            </div> 
        </Modal>
        <!-- 编辑 --> 
        <Modal
            title="编辑出账单位"
            v-model="editliberationVisible" 
            width="60%">
            <div>
                <Form  :model="editliberationData" :rules="editliberationRules" ref="editliberationData" :label-width="150" class="demo-platformData">
                    <div class="plattit">单位信息</div>
                    <el-row>
                        <el-col :span="12">
                            <FormItem label="公司名称" prop="companyName">
                                <Input v-model="editliberationData.companyName"  placeholder="请输入"  :disabled="true"></Input>
                            </FormItem>
                        </el-col> 
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <FormItem label="统一社会信用代码" prop="organizationCode">
                                <Input v-model="editliberationData.organizationCode"  placeholder="请输入"   :maxlength="18"></Input>
                            </FormItem>
                        </el-col>
                        <el-col :span="12">
                            <FormItem label="企业类型" prop="companyType"   v-if="componyType&&componyType.length>0">
                                <Select v-model="editliberationData.companyType"  placeholder="请选择" >
                                    <Option :value="item" v-for="(item,index) in componyType" :key="index">{{item}}</Option> 
                                </Select>
                            </FormItem>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12"> 
                            <FormItem label="所属行业" prop="industry"   v-if="industry&&industry.length>0"> 
                                <Select v-model="editliberationData.industry"  placeholder="请选择" >
                                    <Option :value="item" v-for="(item,index) in industry"  :key="index">{{item}}</Option> 
                                </Select>
                            </FormItem>
                        </el-col>
                        <el-col :span="12">
                            <FormItem label="单位地址" prop="companyAddress">
                                <Area :isRenbao="true" v-model="editliberationData.companyAddress" placeholder="请选择地区" @get-city-str="areaChange" style="width:100%" />
                            </FormItem>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <FormItem label="邮政编码" prop="postCode">
                                <Input v-model="editliberationData.postCode" placeholder="请输入" :maxlength="6"></Input>
                            </FormItem>
                        </el-col>
                        <el-col :span="12">
                            <FormItem label="" prop="detailAddress">
                                <Input v-model="editliberationData.detailAddress" placeholder="请输入详细地址" :maxlength="30"></Input>
                            </FormItem>
                        </el-col>
                    </el-row> 
				    <div style="color: #717276;padding-left: 150px;">请上传10M以内jpg/jpeg格式图片 </div> 
                    <el-row>
                        <el-col :span="12">
                            <FormItem label="营业执照" prop="organizationUrl">
                                <div style="display: flex;">
                                    <div class="demo-upload-list" v-if="editliberationData.organizationUrl.length>0">
                                        <template >
                                            <img :src="editliberationData.organizationUrl">
                                            <div class="demo-upload-list-cover">
                                                <Icon type="ios-eye-outline" @click.native="handleView()"></Icon>
                                                <Icon type="ios-trash-outline" @click.native="handleRemove()"></Icon>
                                            </div>
                                        </template> 
                                    </div>
                                    <Upload
                                        ref="upload"
                                        :show-upload-list="false"
                                        :before-upload="beforeUp"
                                        :default-file-list="defaultList"
                                        :on-success="handleSuccess"
                                        :format="['jpg','jpeg']"  
                                        action="/pc/fileServer/uploadImageReturnThumbnail"
                                    >
                                        <div class="cameraBox" style="width: 58px;height:58px;line-height: 58px;border: 1px solid #eee;">
                                            <Icon type="ios-camera" size="20"></Icon>
                                        </div>
                                    </Upload>
                                </div>   
                            </FormItem>
                        </el-col>
                    </el-row>
                    <div class="plattit">联系人信息</div>
                    <el-row>
                        <el-col :span="12">
                            <FormItem label="姓名" prop="name">
                                <Input v-model="editliberationData.name"  placeholder="请输入"   :disabled="true"></Input>
                            </FormItem>
                        </el-col>
                        <el-col :span="12">
                            <FormItem label="电话" prop="phone">
                                <Input v-model="editliberationData.phone"  placeholder="请输入"   :disabled="true"></Input>
                            </FormItem>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <FormItem label="邮箱" prop="email">
                                <Input v-model="editliberationData.email"  placeholder="请输入"  :disabled="true"></Input>
                            </FormItem>
                        </el-col> 
                    </el-row>
                </Form>      
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editliberationVisible=false">取 消</el-button>
                <el-button type="primary" @click="confirmCompony" :loading="editliberationData.loading">确 定</el-button>
            </span>
        </Modal>
    </div>
    </template> 
    
    <script>
    import ITable from '@/components/common/ITable'
    import Area from '@/pages/haierProduct/components/common/Area'
    
    export default {
        components:{ITable,Area},
        data () { 
            const urlValidator=(rule, value, callback)=>{ 
                if (value === '') {
                    callback(new Error('请上传营业执照'));
                }else {
                    callback();
                } 
            }
            return { 
                columns:[
                    {title: '出账单位名称',slot: 'attachmentUrl',minWidth:200},
                    {title: '统一社会信用代码',key: 'organizationCode',minWidth:220},
                    {title: '企业类型',slot: 'companyType',width:160},
                    {title: '所属行业',slot: 'industry',width:120},
                    {title: '单位地址',slot: 'companyAddressShow',width:230},
                    {title: '邮政编码',key: 'postCode',width:120},
                    {title: '联系人',key: 'name',width:130},
                    {title: '联系电话',key: 'phone',width:150},
                    {title: '联系人邮箱',key: 'email',width:160},
                    {title: '数据完整性',slot: 'dataIntegrity',width:130},
                    {title: '操作',slot: 'action',width:80}
                ],  
                detailVisible:false,
                detail:{},
                editliberationVisible:false,
                editliberationRules:{
                    organizationCode:[ { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
                    companyType:[ { required: true, message: '请选择企业类型', trigger: 'change' }],
                    industry:[ { required: true, message: '请选择所属行业', trigger: 'change' }],
                    companyAddress:[ { required: true, message: '请选择单位地址', trigger: 'change' }],
                    postCode:[ { required: true, message: '请输入邮政编码', trigger: 'blur' }],
                    detailAddress:[ { required: true, message: '请输入详细地址', trigger: 'blur' }],
                    organizationUrl:[ { required: true,validator:urlValidator, trigger: 'change' }],
                },
                editliberationData:{
                    organizationUrl:''
                },
                defaultList:[],
                componyType:[],//公司类型
                industry:[],   //所属行业
                companyUpdated:false
            }
        },
        created () { 
            this.getTypes()
            this.updateBindCompany()  
        }, 
        methods: { 
            // 更新绑定的公司
            updateBindCompany(){
                this.$axios.post('/haierEmpSettlementCompany/bindUser.all').then(res=>{
                    if(res.code==10000000){
                        this.companyUpdated=true
                        // this.$refs.table.getList()
                    }else if(res.code==10000012){
                        if(location.href&&location.href.indexOf('/common.html#/login')==-1){
                            window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
                        }
                    }else{
                        this.$Modal.error({
                            title:'提示',
                            content:res.msg,
                            okText:'返回产品专区',
                            onOk:()=>{
                                // location.href="/haierProduct.html#/"
                                location.href="/company"
                            }
                        })
                    }
                })
            },
            // 打开编辑
            edit(row){
                const obj=JSON.parse(JSON.stringify(row))
                this.editliberationVisible=true
                this.$refs.editliberationData.resetFields()
                this.editliberationData=obj
			    this.$set(this.editliberationData,'organizationUrl',obj.organizationUrl?obj.organizationUrl:'' ) 

            },
            // 确认编辑
            confirmCompony(){
                this.$refs.editliberationData.validate(valid=>{
                    if(valid){
                        this.editliberationData.loading=true
                        this.$refs.editliberationData.validate(valid=>{
                            if(valid){
                                this.$axios.post('/haierEmpSettlementCompany/editCompanyInfo.json',this.editliberationData).then(res=>{
                                    this.toast('保存成功')
                                    this.editliberationData.loading=false
                                    this.$refs.editliberationData.resetFields()
                                    this.editliberationVisible=false
                                    this.$refs.table.getList()
                                }).catch(err=>{
                                    this.editliberationData.loading=false
                                })
                            }
                        })
                    } 
                })
            },
            areaChange(val){ 
                this.editliberationData.companyAddressDesc=''
                val.forEach(i => {
                    this.editliberationData.companyAddressDesc+=i.label
                }) 
            },
            editliberationVisibleCancle(){ 
                this.editliberationVisible=false
                this.$refs.editliberationData.resetFields()
            }, 
            handleSuccess(val){
                this.$set(this.editliberationData,'organizationUrl',val.data)
            }, 
                // 查看营业执照
            openOrganization(){
                window.open(this.detail.organizationUrl)
            },
            // 获取企业类型
            async getTypes () { 
                const res = await this.$axios.get("/haierEmpSettlementCompany/getCommonDropDown",{
                    type:'COMPANY_TYPE'
                })
                const res_ = await this.$axios.get("/haierEmpSettlementCompany/getCommonDropDown",{
                    type:'INDUSTRY'
                })
                this.componyType=res
                this.industry=res_
            },
            handleRemove (file) {
                const fileList = this.$refs.upload.fileList;
                this.editliberationData.organizationUrl=''
                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
            }, 
            toDetail(obj){
                this.detail=obj
                this.detailVisible=true
            },
            beforeUp(val){ 
                if(val.type!='image/jpeg'){
                    this.toast('请上传jpg/jpeg格式营业执照','error')
                    return false
                }
                if(val.size > Number(10)*1024*1024) {
                    this.alert('请上传10M以内jpg/jpeg格式图片');
                    return false
                }
            },
        }
    }
    </script>
    <style scoped lang="less">
    .tips{
        font-size: 14px;
        color: red;
        margin-left: 10px;
    
    }
    .cameraBox{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
    .rowSty{
        padding-left: 20px;
        padding-bottom: 15px;
    }
    .plattit{
        font-weight: 600;
        padding-bottom: 10px;
    }
    .oriang-box{
		display: flex;
		align-items: center;
	}
    .ellipsis {
		overflow: hidden; 
		white-space: nowrap;  
		text-overflow: ellipsis;  
	}
    </style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/group/list/outPay.vue